var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"login-body mb-5"},[(!_vm.showWarning)?_c('h3',{staticClass:"text-center mt-4 mb-4"},[_vm._v(_vm._s(_vm.$t('ACCOUNT.LOGIN')))]):_vm._e(),(_vm.showWarning)?_c('h3',{staticClass:"text-center mt-4 mb-4"},[_vm._v("Obehörig, kontrollera dina referenser")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }